import { HeatingSystem } from '@/util/modbus';

// Returns the measurementTypes that correspond to a table label position.
export function measurementTypesForLabelPos(labelPos: string): string[] | null {
  const labelMeasurementTypeMap: Record<string, string[]> = {
    firstLabel: ['vorlauf', 'einlasstemperatur'],
    secondLabel: ['rücklauf', 'auslasstemperatur'],
  };

  return labelMeasurementTypeMap[labelPos] ?? null;
}

export function metricNameForMeasurementTypes(
  measurements: Array<{ measurementType?: string | null; metricName?: string | null }>,
  measurementTypes: string[],
): string | null {
  return (
    measurements.find((item) => {
      const mt = (item.measurementType ?? '').toLowerCase();
      return measurementTypes.some((measurementType) => mt.includes(measurementType));
    })?.metricName ?? null
  );
}

export function metricNameForLabelPos(
  measurements: Array<{ measurementType?: string | null; metricName?: string | null }> | null | undefined,
  labelPos: string,
): string | null {
  if (!measurements || !Array.isArray(measurements)) return null;

  const measurementTypes = measurementTypesForLabelPos(labelPos);
  if (!measurementTypes) return null;

  return metricNameForMeasurementTypes(measurements, measurementTypes);
}

export function pickMeasurementGroupForLabelPos(
  heatingSystemMeasurementGroups: HeatingSystem['heatingSystemMeasurementGroups'],
  labelPos: string,
  allowDefault = true,
): HeatingSystem['heatingSystemMeasurementGroups'][number] | null {
  if (!Array.isArray(heatingSystemMeasurementGroups) || heatingSystemMeasurementGroups.length === 0) {
    return null;
  }

  const measurementTypes = measurementTypesForLabelPos(labelPos);
  if (!measurementTypes) return heatingSystemMeasurementGroups[0];

  const match = heatingSystemMeasurementGroups.find((group) =>
    group.heatingSystemMeasurements?.some((m) => {
      const mt = (m.measurementType ?? '').toLowerCase();
      return measurementTypes.some((measurementType) => mt.includes(measurementType));
    }),
  );

  if (match) return match;
  return allowDefault ? heatingSystemMeasurementGroups[0] : null;
}
